import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/theme.css';
import App from './App';

/* StrictMode intentionally omitted: react-helmet uses legacy lifecycles
   that spam UNSAFE_componentWillMount warnings under StrictMode. */
ReactDOM.createRoot(document.getElementById('root')).render(<App />);
